import React, { useContext, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import styles from "./styles.module.scss";
import LogoSmall from "../../assets/logo_small.png";
import MenuIcon from "../../assets/menu-icon.svg";
import MobileContext from "../../context/mobile";

export interface IHeaderState {
  isNavOpen: boolean;
}

const Header: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const context = useContext(MobileContext);

  const [headerState, setHeaderState] = useState<IHeaderState>({
    isNavOpen: false,
  });

  const goToContact = () => {
    history.push("/contact");
  };

  const goToHome = () => {
    history.push("/");
  };

  const handleToggleNav = () => {
    setHeaderState({
      ...headerState,
      isNavOpen: !headerState.isNavOpen,
    });
  };

  const desktopLayout = () => {
    return (
      <>
        <div>
          <Link className={styles.link} to="/">
            Home
          </Link>
          <Link className={styles.link} to="/services">
            Services
          </Link>
          <Link className={styles.link} to="/gallery">
            Gallery
          </Link>
          <Link className={styles.link} to="/contact">
            Contact
          </Link>
        </div>
        <div className={styles["contact-container"]}>
          <p>
            Call us on <span>027 511 1166</span> or
          </p>
          <button className={styles["contact-button"]} onClick={goToContact}>
            Get a quote
          </button>
        </div>
      </>
    );
  };

  const mobileLayout = () => {
    const isHome = location.pathname === "/";

    return (
      <>
        <div className={styles["mobile-header-container"]}>
          {isHome ? (
            <button className={styles["contact-button"]} onClick={goToContact}>
              Get a quote
            </button>
          ) : (
            <a onClick={goToHome}>
              <img
                className={styles.logo}
                src={LogoSmall}
                alt="MCP Concrete company logo"
              />
            </a>
          )}
          <button className={styles["menu-button"]} onClick={handleToggleNav}>
            <img className={styles["menu-icon"]} src={MenuIcon} alt="" />
          </button>
        </div>
      </>
    );
  };

  // Note: This disgusts me, make this cleaner ...
  const headerContentStyle = styles["mobile-header-content"];
  const headerContentOpenStyle = styles["mobile-header-content-open"];
  const headerContent = headerState.isNavOpen
    ? [headerContentStyle, headerContentOpenStyle].join(" ")
    : headerContentStyle;

  return (
    <>
      <nav className={styles["header-container"]}>
        {context.isMobile ? mobileLayout() : desktopLayout()}
      </nav>
      {context.isMobile && (
        <div className={headerContent}>
          <div>
            <Link className={styles["link-mobile"]} to="/">
              Home
            </Link>
            <Link className={styles["link-mobile"]} to="/services">
              Services
            </Link>
            <Link className={styles["link-mobile"]} to="/gallery">
              Gallery
            </Link>
            <Link className={styles["link-mobile"]} to="/contact">
              Contact
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
